import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import '../../css/Warehouse.css';
import ListBooking from './ListBooking';

class Booking extends Component {
  constructor(props) {
    super(props);
    var user = reactLocalStorage.getObject('user.info');
    this.part_id = user ? user.user_part_id : null;
    this.user_vhc_type = user ? user.user_vhc_type : null;
  }
  render() {
    return (
      <div>
        <Switch>
          <Route
            exact
            path={`${this.props.match.url}`}
            component={() => (
              <ListBooking
                match_parent={this.props.match}
                part_id={this.part_id}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default Booking;
